import { render, staticRenderFns } from "./sizes.vue?vue&type=template&id=cc9ad1b4&"
import script from "./sizes.vue?vue&type=script&lang=js&"
export * from "./sizes.vue?vue&type=script&lang=js&"
import style0 from "./sizes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc9ad1b4')) {
      api.createRecord('cc9ad1b4', component.options)
    } else {
      api.reload('cc9ad1b4', component.options)
    }
    module.hot.accept("./sizes.vue?vue&type=template&id=cc9ad1b4&", function () {
      api.rerender('cc9ad1b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/pages/info/sizes.vue"
export default component.exports